import { Component, OnInit } from '@angular/core';
import posts from '../inside/posts_data.json';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-inside',
  templateUrl: './inside.component.html',
  styleUrls: ['./inside.component.css']
})
export class InsideComponent implements OnInit {

  public postData = posts;
  public endallpostsLimit = 4;
  public showLoadMore = true;

  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.titleService.setTitle('Blog');
    this.meta.updateTag({
      name: 'description',
      content: 'The OXLDigital Blog: Ideas That Drive Growth'
    });

    const el = document.getElementById('inside');
    if (el) { el.style.backgroundColor = 'red'; }
  }

  loadMore() {
    this.endallpostsLimit = this.postData.length;
    this.showLoadMore = false;
  }

}
